module.exports = __webpack_public_path__ + "img/20200512_162435.85dad46d.jpg";